// hooks/useDoctorQuery.js
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import drEasyApi from "../Api/Customapi";
  import { useLanguage } from "../context/LanguageContext";

const fetchDoctorBySlug = async (slug) => {
  const response = await drEasyApi.get(`/api/Doctor/GetDoctorBySlug/${slug}`);
  return response.data;
};

export const useDoctorQuery = () => {
  const { slug } = useParams();
  const { currentLanguage } = useLanguage();
 
  return useQuery({
    queryKey: ["doctor", slug, currentLanguage], // Add language to query key
    queryFn: () => fetchDoctorBySlug(slug),
    enabled: !!slug,
    retry: false,
  });
  
};